export default require("../../../assets/js/swiper.js");



// WEBPACK FOOTER //
// ./src/components/common/swiper/index.js